import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';

const PercentOfMedicareIPEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);

  const handleChange = (value: string) => {
    if (!contract) return;

    // Parse the value - allow empty strings and invalid numbers to pass through
    const numericValue = value === '' ? 0 : parseFloat(value);
    
    // Update Redux with the numeric value (0 for empty) but only if it's valid or empty
    if (value === '' || (!isNaN(numericValue) && isFinite(numericValue))) {
      dispatch(updateSelectedContract({
        medicareBasedConfig: {
          ...contract.medicareBasedConfig,
          percentOfMedicareIP: numericValue
        }
      }));
    }
  };

  if (!contract) return null;

  // Hide the field if "Based on Medicare" is not checked
  if (!contract.medicareBasedConfig?.basedOnMedicare) {
    return null;
  }

  const ownValue = contract.medicareBasedConfig?.percentOfMedicareIP ?? 0;
  // Fallback: show legacy percentOfMedicare when the IP-specific field is unset
  const legacyValue = contract.medicareBasedConfig?.percentOfMedicare ?? 0;
  const displayValue = ownValue !== 0 ? ownValue : legacyValue;

  return (
    <TextField
      label="% of Medicare (IP)"
      value={displayValue === 0 ? '' : displayValue}
      onChange={(e) => handleChange(e.target.value)}
      type="number"
      inputProps={{
        step: 1,
        min: 0,
        max: 999.99
      }}
      fullWidth
      size="small"
      variant="outlined"
    />
  );
};

export default PercentOfMedicareIPEditor;
